import { createAction, props } from '@ngrx/store';

export const finish = createAction('[Finish] finish', props<{payload: any}>());

